import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ColDef, DomLayoutType, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { SharedService } from 'src/app/shared/shared.service';
import { DomainConfigValueRendererComponent } from '../../grid-store-cell-renderers/domain-config-value-renderer/domain-config-value-renderer.component';
import { PaginationPageSizes } from 'src/app/constants';
import { AppDataModel } from 'src/app/features/store/models/storeModel';
import { EditDeleteButtonRendererComponent } from '../../grid-store-cell-renderers/edit-delete-button-renderer/edit-delete-button-renderer.component';

@Component({
  selector: 'app-enabled-domain-users',
  templateUrl: './enabled-domain-users.component.html',
  styleUrls: ['./enabled-domain-users.component.scss']
})
export class EnabledDomainUsersComponent implements OnInit, OnChanges {

  @Input() rowData: any;

  @Input() tableConfigOptions: any;

  @Input() anyChange: boolean;

  @Input() allUsersSearchText: string;

  @Input() configOptionsOnChanges: any;

  @Input() tiersArr: Array<string>;

  @Input() isCustomerWebhookPresent: boolean;

  @Input() appDetailsData: AppDataModel;

  gridApi: GridApi;

  // public frameworkComponents: any;

  @Output() rowSelectedEvent = new EventEmitter();

  @Output() rowEditedEvent = new EventEmitter();

  @Output() webhookEditDeleteEvent = new EventEmitter();

  gridOptions: GridOptions;

  rowSelection: "single" | "multiple" = "multiple";

  selectedRows: any;

  idString = 'manage-domains';

  public columnDefs: ColDef[] = [
    {
      headerName: 'Domain',
      field: 'domain',
      sort: 'asc',
      comparator: this.sharedService.textComparator
    },
    {
      headerName: 'Value',
      field: 'config_value',
      sortable: false,
      cellRenderer: 'confgValueRenderer',
      headerClass: 'header-label-center',
    },
    {
      headerName: 'Action',
      sortable: false,
      cellRenderer: 'editDeleteButtonRenderer',
      headerClass: 'header-label-center',
    }
  ];

  public defaultColDef: ColDef = {
    sortable: true
  };

  public domLayout: DomLayoutType;

  style: any = {
    width: '100%',
    height: '100%'
  };

  public paginationPageSize = 10;

  paginationPageSizes = PaginationPageSizes;

  constructor(private sharedService: SharedService) {
  }

  ngOnInit(): void {
    this.compInit();
  }

  compInit() {
    this.gridOptions = {
      components: {
        confgValueRenderer: DomainConfigValueRendererComponent,
        editDeleteButtonRenderer: EditDeleteButtonRendererComponent
      },
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      animateRows: true,
      pagination: true,
      paginationPageSize: this.paginationPageSize,
      alwaysShowHorizontalScroll: false,
      context: { componentParent: this },
      onRowSelected: ($event) => {
        this.onRowSelected($event)
      },
      onRowDoubleClicked: ($event) => {
        this.onRowDoubleClicked($event);
      },
      onGridReady: ($event) => {
        this.onGridReady($event);
      },
      onSortChanged: () => {
        // const sortModel = this.gridApi.getSortModel()[0];
        // if (sortModel) {

        // }
      },
      onFilterChanged: () => {
        // const filterModel = this.gridApi.getFilterModel();
      }
    }
    this.operateTableConfigs();
  }

  operateTableConfigs() {
    this.domLayout = (this.tableConfigOptions && this.tableConfigOptions.domLayoutType) ? this.tableConfigOptions.domLayoutType : 'autoHeight';
    if (this.tableConfigOptions) {
      if (this.tableConfigOptions.columns && this.tableConfigOptions.columns.length)
        this.tableConfigOptions.columns.forEach((item: any) => {
          this.columnDefs.forEach(column => {
            if (item.headerName === column.headerName) {
              column.hide = item.hide;
            }
          });
        });
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  }

  onRowSelected(event: any) {
    this.getSelectedRows();
  }

  getSelectedRows() {
    const selectedNodes = this.gridApi.getSelectedNodes();
    this.selectedRows = selectedNodes.map(node => node.data);
    this.rowSelectedEvent.emit(this.selectedRows);
  }

  onRowDoubleClicked(event: any) {
    this.rowEditedEvent.emit(event.data);
  }

  clearRowSelection() {
    if (this.gridApi) {
      this.gridApi.deselectAll();
    }
  }

  onPageSizeChanged() {
    this.gridApi.paginationSetPageSize(Number(this.paginationPageSize));
  }

  handleClick(action: string, rowData: any) {
    console.log(action);
    console.log(rowData);
    const tempObj = {
      action: action,
      rowData: rowData,
      domain_mgmt_enabled: this.configOptionsOnChanges.domain_mgmt_enabled,
      domain_tiers_enabled: this.configOptionsOnChanges.domain_tiers_enabled,
      tiersArr: this.tiersArr
    }
    this.webhookEditDeleteEvent.next(tempObj);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('abcd enabled row data on change', this.rowData);
    if ((this.anyChange) && this.gridApi) {
      this.gridApi.sizeColumnsToFit();
      this.anyChange = false;
    }
    if (this.allUsersSearchText && this.gridApi) {
      this.gridApi.setQuickFilter(this.allUsersSearchText)
    } else if (!this.allUsersSearchText && this.gridApi) {
      this.gridApi.setQuickFilter('')
    }

    if (this.configOptionsOnChanges && this.configOptionsOnChanges.isClearSelection) {
      this.clearRowSelection();
    }
  }
}
